// extracted by mini-css-extract-plugin
var _1 = "TruncatedText-module__truncatedText--AowlS";
export { _1 as "truncatedText" }
